import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import './index.css';
import logo from './assets/spinner.gif'
import { performUserLogin } from "./functions";

function Login() {
  console.log('Login page load');
  // const cookies = new Cookies();
  // cookies.set('login', null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [logintext, setLogintext] = useState('');

  const onSubmit = async (data) => {
    setLoading(true);
    setLogintext("Verifying...");
    let loggedIn = await performUserLogin(data.email, data.password);
    if (loggedIn) {
      setLogintext("Login successful - redirecting");
      setTimeout(() => {
        console.log('Navigating to Home page');
        navigate('/');
      }, 2000);
    } else {
      setLogintext("**Login Failed**");
      //setLoading(false);
    }
  };

  return (
    <>
      <p className="title">Login Form</p>

      <form className="Login" onSubmit={handleSubmit(onSubmit)}>
        <input type="email" placeholder="Email Address" {...register("email", { required: true })} />
        <input type="password" placeholder="Password" {...register("password")} />
        <input className="bg-brown" type={"submit"} />
      </form>
      <br />
      <div id="loginResponse">
        {loading ? (
          <>{logintext}<br /><img src={logo} style={{ width: '50px' }} alt="loading..." /> </>
        ) : (<></>)}
        {errors.email && <span className="loginSpan">
          *Email* is mandatory </span>}
      </div>
      <br />
      <p>
        Don't have an account? <Link to="/signup">Sign up here</Link>
      </p>
    </>
  );
}

export default Login;
//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<Login />);
